export default "__VITE_ASSET__17098335__"